module.exports = __webpack_public_path__ + "static/media/diarista.0fc219fd.jpg";